import { CSService } from '@pulseops/common'
import React from 'react'

type CSProcessGuidelineDocContextData = {
  docTypeList: Array<CSService.DocTypeInfo>
  docTypeDetailList: Array<CSService.DocTypeDetailInfo>
}
const defaultValues:CSProcessGuidelineDocContextData = {
  docTypeList: [],
  docTypeDetailList: []
}
export const CSProcessGuidelineDocContext = React.createContext<CSProcessGuidelineDocContextData>(defaultValues)